import { DefaultTriggerNode, ManualyTriggerNode, TriggerNode } from "./defaultTriggerNode";
import DefaultNode from "./defaultNode";
import { AiAgentNode } from "./aiAgent";
import { OpenAINode } from "./openAINode";
import { FilterNodeModal } from "../modals/filterNodeModal";
import { OpenAiModal } from "../modals/openAiModal";
import { ExcelExportNodeModal } from "../modals/excelExportNodeModal";
import { WordExportNodeModal } from "../modals/wordExportNodeModal";
import { TimeTriggerModal } from "../modals/timeTriggerModal";
import { NoteNode } from "./noteNode";
import { DefaultToolNode } from "./defaultToolNode";

export const getNodeComponentByType = (type) => {
  switch (type) {
    case "trigger.manual":
      return DefaultTriggerNode;
    case "trigger.event":
      return DefaultTriggerNode;
    case "trigger.schedule":
      return DefaultTriggerNode;
    case "ai.agent":
      return AiAgentNode;
    case "data.model":
      return DefaultNode;
    case "data.filter":
      return DefaultNode;
    case "ai.openai":
      return DefaultToolNode;
    case "report":
      return ReportNode;
    case "data.exporttoexcel":
      return DefaultNode;
    case "file.download":
      return DownloadFileNode;
    case "section.note":
      return NoteNode;
    case "comms.teams":
      return DefaultNode; // Assuming you have a Teams node
    case "comms.outlook":
      return DefaultNode; // Assuming you have an Outlook node
    default:
      return DefaultNode;
  }
};

export const nodeTypes = {
  "trigger.manual": DefaultTriggerNode,
  "trigger.event": DefaultTriggerNode,
  "trigger.schedule": DefaultTriggerNode,
  "data.model": DefaultNode,
  "data.filter": DefaultNode,
  "ai.agent": AiAgentNode,
  "tool.openai": DefaultToolNode,
  "tool.grok": DefaultToolNode,
  "tool.gaugememory": DefaultToolNode,
  "data.exporttoexcel": DefaultNode,
  "data.exporttoword": DefaultNode,
  "section.note": NoteNode,
  "comms.teams": DefaultNode,
  "comms.outlook": DefaultNode,
  report: DefaultNode,
  default: DefaultNode,
};

export const modalComponents = {
  "data.filter": FilterNodeModal,
  "ai.openai": OpenAiModal,
  "trigger.schedule": TimeTriggerModal,
  "data.exporttoexcel": ExcelExportNodeModal,
  "data.exporttoword": WordExportNodeModal,
};
